import React, { useState } from 'react';
import { MessageSquare, Plus } from 'lucide-react';
interface Note {
  id: number;
  author: string;
  initials: string;
  timestamp: string;
  body: string;
}
const initialNotes: Note[] = [{
  id: 1,
  author: 'Danielle Okafor',
  initials: 'DO',
  timestamp: 'Today, 9:42 AM',
  body: 'Pulled subject rent from the 1007 — $3,200 supports a 1.12 DSCR at the note rate. Proceeding on the DSCR track, no personal DTI.'
}, {
  id: 2,
  author: 'Priya Nathan',
  initials: 'PN',
  timestamp: 'Yesterday, 4:18 PM',
  body: "Heads up — subject sits in flood Zone AE, so we'll want the flood binder confirmed before clearing. Flagging for the file."
}];
export function UnderwriterNotes() {
  const [notes, setNotes] = useState<Note[]>(initialNotes);
  const [draft, setDraft] = useState('');
  const handlePost = () => {
    const trimmed = draft.trim();
    if (!trimmed) return;
    const newNote: Note = {
      id: Date.now(),
      author: 'You',
      initials: 'YOU',
      timestamp: 'Just now',
      body: trimmed
    };
    setNotes(prev => [newNote, ...prev]);
    setDraft('');
  };
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-282">
      <div className="px-5 py-4 flex items-center gap-2 border-b border-slate-200" data-id="element-283">
        <MessageSquare className="w-5 h-5 text-slate-500" data-id="element-284" />
        <h2 className="font-semibold text-slate-900" data-id="element-285">
          Underwriter Internal Notes
        </h2>
      </div>

      <div className="p-5 border-b border-slate-100" data-id="element-286">
        <label htmlFor="internal-note" className="sr-only" data-id="element-287">
          Add an internal note
        </label>
        <textarea id="internal-note" value={draft} onChange={e => setDraft(e.target.value)} placeholder="Add an internal note…" rows={3} className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y" data-id="element-288" />
        <div className="flex justify-end mt-3" data-id="element-289">
          <button type="button" onClick={handlePost} disabled={!draft.trim()} className="inline-flex items-center gap-1.5 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-290">
            <Plus className="w-4 h-4" data-id="element-291" />
            Post
          </button>
        </div>
      </div>

      <ul className="divide-y divide-slate-100" data-id="element-292">
        {notes.map(note => <li key={note.id} className="p-5" data-id="element-293">
            <div className="flex items-start gap-3" data-id="element-294">
              <div className="w-9 h-9 shrink-0 rounded-full bg-slate-200 text-slate-600 flex items-center justify-center text-xs font-semibold" data-id="element-295">
                {note.initials}
              </div>
              <div className="min-w-0" data-id="element-296">
                <div className="flex items-baseline justify-between gap-3" data-id="element-297">
                  <span className="text-sm font-semibold text-slate-900" data-id="element-298">
                    {note.author}
                  </span>
                  <span className="text-xs text-slate-400 shrink-0" data-id="element-299">
                    {note.timestamp}
                  </span>
                </div>
                <p className="text-sm text-slate-600 mt-1 leading-relaxed" data-id="element-300">
                  {note.body}
                </p>
              </div>
            </div>
          </li>)}
      </ul>
    </div>;
}